import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const checkVersion = async () => {
    try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        
        if (!response.ok) {
            console.error('Failed to fetch version configuration');
            return true;
        }
        
        const data = await response.json();
        const { version, maintenanceMode } = data;
        const cachedVersion = localStorage.getItem('app-version');

        // Check if maintenance mode is enabled
        if (maintenanceMode === true && window.location.pathname !== '/maintenance') {
            window.location.href = '/maintenance';
            return false;
        }

        // If maintenance mode is off and we're on the maintenance page, redirect to home
        if (maintenanceMode === false && window.location.pathname === '/maintenance') {
            window.location.href = '/';
            return false;
        }

        if (cachedVersion && cachedVersion !== version) {
            localStorage.setItem('app-version', version);
            window.location.reload(); // Force reload to fetch the latest files
        } else {
            localStorage.setItem('app-version', version);
        }
        
        return true;
    } catch (error) {
        console.error('Failed to fetch version:', error);
        return true;
    }
};

checkVersion().then((shouldRender) => {
    if (shouldRender) {
        root.render(
            <BrowserRouter basename={baseUrl}>
                <App />
            </BrowserRouter>
        );
    }
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
